import { useMemo } from 'react';
import { useQuery } from 'hooks';
import { RegistrationFormData } from 'contexts/registration';
import { SessionStorageKey, sessionStorageService } from '../utils/SessionStorageService';
// import moment from 'moment';

export const useRegistrationStateQuery = () => {
  const query = useQuery();

  const storedRegistration = JSON.parse(
    sessionStorageService.get(SessionStorageKey.RegisterData) ?? '{}',
  ) as RegistrationFormData;
  return useMemo<RegistrationFormData>(
    () => ({
      email: query.get('email') || storedRegistration.email || '',
      policyNumber: query.get('policyNumber') || storedRegistration.policyNumber || '',
      memberId: query.get('memberId') || storedRegistration.memberId || '',
      memberType: query.get('memberType') || storedRegistration.memberType || '',
      memberName: query.get('memberName') || storedRegistration.memberName || '',
      principalName: query.get('principalName') || storedRegistration.principalName || '',
      mobile: storedRegistration.mobile || '',
      selfDefinedLoginId: query.get('selfDefinedLoginId') || storedRegistration.selfDefinedLoginId || '',
      password: storedRegistration.password || '',
      confirmPassword: storedRegistration.confirmPassword || '',
      countryCode: storedRegistration.countryCode,
      dob: storedRegistration.dob || '',
      verifiedMobileNumber: storedRegistration.verifiedMobileNumber,
      localization: storedRegistration.localization,
      registerError: storedRegistration.registerError,
      identityNo: storedRegistration.identityNo,
      isEmailRegister: !!query.get('email'),
      areaCode: storedRegistration.areaCode || '',
    }),
    [query, storedRegistration],
  );
};
